import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IDataService } from "../Interfaces/idata-service";
import { IServiceResponse, IAlgoSwitchesR as IAlgoSwitches, IAlgoSwitchesRq } from '../Interfaces/iservice-response';
import { IServiceRequest } from "../Interfaces/iservice-request";
import { ISymbolData } from "../Interfaces/isymbol-data";
import { IAppSettings } from "../Interfaces/iapp-settings";
import * as moment from "moment";
import { ConfigService, Config } from "./config.service";
import { DgHubClientService, RetracementSettingsRequest } from "./dg-hub-client.service";

import { UTCTimestamp } from "lightweight-charts";
import { ISendTradeData, IInitResponse, ISendTradeDataResponse } from "../Models/HubModels";
import { ILoginResponseModel, UnauthorizedRs } from "../Models/HubModels/LoginResponseModel";
import { CookiesService } from "./cookieService";


@Injectable({
  providedIn: "root"
})
export class DataService implements IDataService {
  static TYPE_ADD: string = "add";
  static TYPE_DELETE: string = "delete";
  static TYPE_RESET: string = "reset";

  dataSubscriber: Subject<IServiceResponse> = new Subject<IServiceResponse>();
  tradeDataSubscriber: Subject<ISendTradeDataResponse> = new Subject<ISendTradeDataResponse>();
  initSubscriber: Subject<IInitResponse> = new Subject<IInitResponse>();
  retracementSettingsSubscriber: Subject<RetracementSettingsRequest> = new Subject<RetracementSettingsRequest>();

  public appSettings: IAppSettings = {
    WebSocketUrl: "",
    SignalRUrl: "",
    SocketReconnect: 5,
    SocketPingInterval: 20,
    SocketTimeout: 60,
    TrySendTimeout: 5,
    TrySendCount: 5,
    SingalSizeAmount:10
  };

  private _systemVersion: string = "";
  public get systemVersion(): string {
    return this._systemVersion;
  }
  public set systemVersion(value: string) {
    this._systemVersion = value;
  }

  constructor(private _configService: ConfigService, private _hubservice: DgHubClientService, private cookieService: CookiesService) {


    this.systemVersion = this.getMobileOperatingSystem();
    this._configService.getConfig()

      // clone the data object, using its known Config shape
      .subscribe((data: Config) => {

        this.appSettings.SignalRUrl = data.signalRUrl;
        this.appSettings.SingalSizeAmount = data.singalSizeAmount;

        this._hubservice.baseUrl = data.signalRUrl;

        this._hubservice.InitResponse.subscribe(v => {
          this.initSubscriber.next(v);
        });

        this._hubservice.SendWaveResponse.subscribe(v => {
          //console.log(v);
        });

        this._hubservice.SendTradeData.subscribe(v => {
          this.tradeDataSubscriber.next(v);
         
        });


        this._hubservice.ConnectLogin();

        this._hubservice.connectionLogin.on("LoginResponse", (r: ILoginResponseModel) => {

          if (r.token != null) {

            if (!this._hubservice.lastLogin) {
              this._hubservice.lastLogin = this.cookieService.getCookie("_ll");
            }


            if (!this._hubservice.lastLogin) {
              this.cookieService.setCookie("_tk", '', 1, "/");
              window.location.href = "/";
              console.log("sitereload_type2");
            }
            else {

              this.cookieService.setCookie("_tk", r.token, 1, "/");
              this.cookieService.setCookie("_ll", this._hubservice.lastLogin, 1, "/");

              if (this._hubservice.dialogLogin) {
                this._hubservice.dialogLogin.close();
              }

              this._hubservice.connected = true;

              this._hubservice.ConnectMain();
            }
          }


        });

        this._hubservice.connectionLogin.on("LoginErrorResponse", (r: UnauthorizedRs) => {
          this._hubservice.showLogin(r.error);

        })


      })
  }
  public getMobileOperatingSystem() {
    var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

if (macosPlatforms.indexOf(platform) !== -1) {
  os = 'iOS';
} else if (iosPlatforms.indexOf(platform) !== -1) {
  os = 'iOS';
} else if (windowsPlatforms.indexOf(platform) !== -1) {
  os = 'Windows';
} else if (/Android/.test(userAgent)) {
  os = 'Android';
} else if (!os && /Linux/.test(platform)) {
  os = 'Linux';
}

return os;
  }

  public getHubCLientService() {
    return this._hubservice
  }
}
